export const readClientCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  if (!match?.[1]) return null;
  return decodeURIComponent(match[1]);
};

export const setClientCookie = (
  name: string,
  value: string,
  maxAge: number,
  path: string = '/',
): void => {
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=${path}`;
};

export const deleteClientCookie = (name: string, path: string = '/'): void => {
  document.cookie = `${name}=; max-age=0; path=${path}`;
};
